import { getUserBalances } from '$lib/data/main';
import { getStablesPrices } from '$lib/data/matchaCallData';
import {
	addFundsAmount,
	addFundsToken,
	addFundsTokenAmount,
	processingFundDeposit,
	processingFundWithdraw,
	smartContractWalletAddress,
	withdrawFundsTokenAmount,
	withdrawToken
} from '$lib/home/scwallet/store';
import { userBalances } from '$lib/home/store';
import {
	addErrorNotification,
	addTransactionNotification
} from '$lib/notifications/notificationManager';
import { optimismTokensConfig } from '$lib/tokensConfig';
import { toBN } from '$lib/util/util';
import { logAnalytcisEvent } from '$lib/util/analytics';
import { walletAddress } from '$lib/wallet/store';
import {
	addETHFundsToSCW,
	addFundsToSCW,
	withdrawTokenFromSCW
} from '$lib/web3/actions/scwModifiers';
import { getParsedError } from '$lib/web3/errorHandling';
import type { SendTransactionResult } from '@wagmi/core';
import { get } from 'svelte/store';

export async function executeWithdrawFunds(input: string) {
	try {
		processingFundWithdraw.set(true);
		let tx: SendTransactionResult = await withdrawTokenFromSCW(
			optimismTokensConfig[get(withdrawToken)].address,
			get(smartContractWalletAddress) as `0x${string}`,
			get(withdrawFundsTokenAmount),
			get(walletAddress) as `0x${string}`
		);
		addTransactionNotification(
			'Funds Withdrawn',
			`${input} ${get(withdrawToken)} have been transfered from Polynomial wallet to your wallet.`,
			tx,
			() => {
				input = '0';
				withdrawFundsTokenAmount.set(toBN('0'));
				getUserBalances();
				getStablesPrices(get(userBalances));
				processingFundWithdraw.set(false);
			}
		);
		processingFundWithdraw.set(false);
	} catch (e: any) {
		const { title, description } = getParsedError(e);
		addErrorNotification(title, description, JSON.stringify(e));
		processingFundWithdraw.set(false);
	}
}

export async function executeAddFunds(input: string) {
	try {
		processingFundDeposit.set(true);
		let tx: SendTransactionResult;
		if (get(addFundsToken) == 'ETH') {
			tx = await addETHFundsToSCW(
				get(smartContractWalletAddress) as `0x${string}`,
				get(addFundsTokenAmount)
			);
		} else {
			tx = await addFundsToSCW(
				optimismTokensConfig[get(addFundsToken)].address as `0x${string}`,
				get(smartContractWalletAddress) as `0x${string}`,
				get(addFundsTokenAmount)
			);
		}
		logAnalytcisEvent('click_sc_wallet_deposit', {
			token: optimismTokensConfig[get(addFundsToken)].address,
			amount: get(addFundsTokenAmount).toString()
		});
		addTransactionNotification(
			'Funds Deposited',
			`${input} ${get(addFundsToken)} have been transfered from Polynomial wallet to your wallet.`,
			tx,
			() => {
				input = '0';
				addFundsTokenAmount.set(toBN('0'));
				getUserBalances();
				processingFundDeposit.set(false);
			}
		);
	} catch (e: any) {
		const { title, description } = getParsedError(e);
		addErrorNotification(
			title,
			description,
			JSON.stringify(e, (key, value) => (typeof value === 'bigint' ? value.toString() : value))
		);
		processingFundDeposit.set(false);
	}
}
